import { Application } from "stimulus";
import { definitions } from "stimulus:../controllers";

// we need to include this manually as the current builder doesnt currently support it
import { initializeHanamiUjs } from "../vendor/hanamiUjs";

import { appsignal } from "./appsignal";

const application = Application.start();

application.handleError = (error, message, detail) => {
  if (process.env.HANAMI_ENV === "development") {
    // propagate errors that happen inside Stimulus controllers
    throw error;
  } else {
    console.error(error, message, detail);
    let outerHTML;
    if (detail.element) {
      outerHTML = detail.element.outerHTML;
    }

    const span = appsignal.createSpan((span) => {
      const tags = {
        framework: "Stimulus",
        message: message,
        element: outerHTML,
        url: window.location.href,
      };
      return span.setTags(tags).setError(error);
    });

    appsignal.send(span);
  }
};

application.load(definitions);

initializeHanamiUjs();
